/*
  RAWS cart CRO — keeps the bundle progress bar (<raws-multibuy>, snippets/free-shipping-bar.liquid)
  and the product page bundle line (<raws-bundle-offer>, snippets/raws-bundle-offer.liquid)
  in sync with the cart without a page reload.

  The bar is rendered in Liquid first. After any cart write (add / change / update / clear, made by
  the theme or by an app, via fetch or XHR) this re-reads /cart.js and updates every bar on the page.
  It watches network activity through PerformanceObserver, so it never patches fetch or XHR.

  If RAWSMULTI changes, update THRESHOLD / PCT here AND in snippets/free-shipping-bar.liquid
  and snippets/raws-bundle-offer.liquid.
*/
(function () {
  'use strict';
  if (window.__rawsCartCro) return;
  window.__rawsCartCro = true;

  var THRESHOLD = 3;
  var PCT = 25;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastCart = null;
  var pending = false;
  var timer = null;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function render(el, cart) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || THRESHOLD;
    var pct = parseInt(el.getAttribute('data-pct'), 10) || PCT;
    var count = cart.item_count || 0;
    var needed = threshold - count;

    el.hidden = count === 0;
    el.classList.toggle('is-unlocked', needed <= 0);

    var msg = el.querySelector('[data-raws-msg]');
    if (msg) {
      if (needed <= 0) {
        var save = cart.total_discount > 0
          ? ' <span class="raws-cro__save">— you’re saving ' + money(cart.total_discount, cart.currency) + '</span>'
          : '';
        msg.innerHTML = '<strong>' + pct + '% off unlocked</strong>' + save;
      } else {
        msg.innerHTML = 'Add <strong>' + needed + ' more item' + (needed === 1 ? '' : 's') +
          '</strong> to unlock ' + pct + '% off';
      }
    }

    var countEl = el.querySelector('[data-raws-count]');
    if (countEl) countEl.textContent = Math.min(count, threshold) + '/' + threshold;

    var segs = el.querySelectorAll('.raws-cro__seg');
    for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-on', count > i);
  }

  // Product page bundle line (<raws-bundle-offer>, snippets/raws-bundle-offer.liquid)
  function renderOffer(el, cart) {
    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || THRESHOLD;
    var pct = parseInt(el.getAttribute('data-pct'), 10) || PCT;
    var count = cart.item_count || 0;
    var needed = threshold - count;

    el.classList.toggle('is-unlocked', count > 0 && needed <= 0);

    var msg = el.querySelector('[data-raws-offer-msg]');
    if (!msg) return;
    if (count === 0) {
      msg.innerHTML = '<strong>Buy any ' + threshold + ', save ' + pct + '%</strong> — applied automatically';
    } else if (needed <= 0) {
      msg.innerHTML = '<strong>' + pct + '% off unlocked</strong> — on everything in your cart';
    } else {
      msg.innerHTML = '<strong>' + count + ' in your cart</strong> — add ' + needed + ' more to save ' + pct + '%';
    }
  }

  function applyAll(cart) {
    lastCart = cart;
    var els = document.querySelectorAll('raws-multibuy');
    for (var i = 0; i < els.length; i++) render(els[i], cart);
    var offers = document.querySelectorAll('raws-bundle-offer');
    for (var j = 0; j < offers.length; j++) renderOffer(offers[j], cart);
  }

  function refresh() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { pending = false; if (cart) applyAll(cart); })
      .catch(function () { pending = false; });
  }

  function schedule() {
    pending = true;
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  // Watch for cart writes made by anything on the page (theme, Upsell.com, quick add, etc.)
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (CART_WRITE.test(entries[i].name)) { schedule(); return; }
        }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* older browsers: Liquid render still shows the correct state on load */ }
  }

  // Back/forward cache restores a stale page: re-read the cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  // The drawer is cloned from a <template> each time it opens. If the cart changed on this page
  // since that template was rendered, bring the freshly connected bar up to date.
  if (!customElements.get('raws-multibuy')) {
    customElements.define('raws-multibuy', class extends HTMLElement {
      connectedCallback() {
        if (lastCart && !pending) render(this, lastCart);
      }
    });
  }
  if (!customElements.get('raws-bundle-offer')) {
    customElements.define('raws-bundle-offer', class extends HTMLElement {
      connectedCallback() {
        if (lastCart && !pending) renderOffer(this, lastCart);
      }
    });
  }

  // Express checkout in the cart drawer (snippets/raws-cart-express.liquid). The buttons arrive
  // in a <template>; place exactly one copy right after <cart-drawer-buttons-block>, and put it
  // back if the drawer re-renders its footer.
  if (!customElements.get('raws-express-checkout')) {
    customElements.define('raws-express-checkout', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('[data-sidebar-body]') || this.closest('cart-drawer');
        if (!this.scope) return;
        this.place();
        if (!this.observer) {
          var self = this;
          this.observer = new MutationObserver(function () { self.place(); });
          this.observer.observe(this.scope, { childList: true, subtree: true });
        }
      }
      disconnectedCallback() {
        if (this.observer) { this.observer.disconnect(); this.observer = null; }
      }
      place() {
        var buttons = this.scope.querySelector('cart-drawer-buttons-block');
        var tpl = this.querySelector('template');
        if (!buttons || !tpl) return;
        var next = buttons.nextElementSibling;
        if (next && next.classList.contains('raws-express')) return;
        var stale = this.scope.querySelectorAll('.raws-express');
        for (var i = 0; i < stale.length; i++) stale[i].remove();
        var node = document.importNode(tpl.content, true).firstElementChild;
        if (node) buttons.insertAdjacentElement('afterend', node);
      }
    });
  }

  // Product pages: a size has to be picked before Add to cart (main button, the theme's mobile
  // sticky button and quick view). The theme pre-selects the first available size, so a quick tap
  // on Add to cart used to add XS/S by default. Only real taps/keys on a size count as picking.
  var SIZE_NAME = /size/i;
  var sizePicked = {};

  function sizeRadioFrom(target) {
    if (!target || !target.closest) return null;
    if (target.type === 'radio' && SIZE_NAME.test(target.name || '') && target.getAttribute('form')) return target;
    var label = target.closest('label[for]');
    if (!label) return null;
    var input = document.getElementById(label.getAttribute('for'));
    return input && input.type === 'radio' && SIZE_NAME.test(input.name || '') && input.getAttribute('form') ? input : null;
  }

  function markPicked(e) {
    if (!e.isTrusted) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    var input = sizeRadioFrom(e.target);
    if (!input) return;
    sizePicked[input.getAttribute('form')] = true;
    var picker = input.closest('variant-picker');
    if (!picker) return;
    var notes = picker.querySelectorAll('.raws-size-note');
    for (var i = 0; i < notes.length; i++) notes[i].remove();
    var groups = picker.querySelectorAll('.raws-size-needed');
    for (var j = 0; j < groups.length; j++) groups[j].classList.remove('raws-size-needed');
  }
  document.addEventListener('click', markPicked, true);
  document.addEventListener('change', markPicked, true);
  document.addEventListener('keydown', markPicked, true);

  function askForSize(input) {
    var picker = input.closest('variant-picker') || document;
    var groups = picker.querySelectorAll('[data-variant-picker-option-labels]');
    var group = null;
    for (var i = 0; i < groups.length; i++) {
      if ((groups[i].getAttribute('option-picker-name') || '') === input.name) { group = groups[i]; break; }
    }
    group = group || (picker === document ? null : picker);
    if (!group) return;
    group.classList.remove('raws-size-needed');
    void group.offsetWidth;
    group.classList.add('raws-size-needed');
    if (!group.querySelector('.raws-size-note')) {
      var note = document.createElement('p');
      note.className = 'raws-size-note';
      note.setAttribute('role', 'alert');
      note.textContent = 'Select your size';
      group.appendChild(note);
    }
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[name="add"]') : null;
    if (!btn || btn.disabled) return;
    var holder = btn.closest('product-form');
    var form = holder && holder.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || !form.id || sizePicked[form.id]) return;
    var sizes = Array.prototype.filter.call(
      document.querySelectorAll('input[type="radio"][form="' + form.id + '"]'),
      function (i) { return SIZE_NAME.test(i.name || ''); }
    );
    if (sizes.length < 2) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    askForSize(sizes[0]);
  }, true);
})();